var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{staticClass:"container"},[_c('h3',{staticClass:"text-center text-secondary"},[_vm._v("Error 404! Sorry the page you are looking for could not be found!!!")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }